// extracted by mini-css-extract-plugin
export default {"loginContainer":"LoginStack_loginContainer__Tp0N7","logo":"LoginStack_logo__Tyzbw"};